export interface PlayerSportLevel {
  sport: string;
  level: 'Iniciante' | 'Intermediário' | 'Avançado';
}

export const PLAYER_SPORT_LEVELS: PlayerSportLevel[] = [
  { sport: 'Beach Tennis', level: 'Intermediário' },
  { sport: 'Futevôlei', level: 'Iniciante' },
  { sport: 'Pickleball', level: 'Iniciante' },
];
